import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=5d80cc5f&scoped=true&"
import script from "./Activities.vue?vue&type=script&lang=js&"
export * from "./Activities.vue?vue&type=script&lang=js&"
import style0 from "./Activities.vue?vue&type=style&index=0&id=5d80cc5f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d80cc5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d80cc5f')) {
      api.createRecord('5d80cc5f', component.options)
    } else {
      api.reload('5d80cc5f', component.options)
    }
    module.hot.accept("./Activities.vue?vue&type=template&id=5d80cc5f&scoped=true&", function () {
      api.rerender('5d80cc5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/tools/vistas/Activities.vue"
export default component.exports